let forms = [];

export const all = () => {
    if (!forms)
        forms = [];
    return forms;
}

export const add = (prefix, form, Vue) => {
    if (!forms)
        forms = []

    Vue.component(prefix, form);
    forms.push({
        prefix,
        form
    });
};

export default { all, add };